import { useEffect } from "react";
import { Icon, Input, InputGroup, Popover, Whisper } from "rsuite";
import { useDataset } from "../DataSet/DatasetProvider";
import { StandardFilterProps } from "../types";

interface IDynamicTextSearchProps extends StandardFilterProps {}
const DynamicTextSearch = (props: IDynamicTextSearchProps) => {
  const {
    getFilterValue,
    setFilterValue,
    getFiltersStateParam,
    setFiltersStateParam,
  } = useDataset();

  const rawFilterValue = getFilterValue(props.filterDef.code);
  const filterValue = typeof rawFilterValue === "string" ? rawFilterValue : "";

  const minLength =
    typeof props.filterDef.args?.minLength === "number"
      ? props.filterDef.args.minLength
      : 3;

  const inputValue: string = getFiltersStateParam(
    props.filterDef.code,
  ) as string;

  const handleClear = () => {
    setFilterValue(props.filterDef.code, "");
    setFiltersStateParam(props.filterDef.code, "");
  };

  useEffect(() => {
    if (filterValue.length === 0) {
      setFiltersStateParam(props.filterDef.code, "");
    }
  }, [filterValue, props.filterDef.code, setFiltersStateParam]);

  const speaker = (
    <Popover className={filterValue.length >= minLength ? "hidden" : ""}>
      <p>Please enter a minimum of {minLength} characters to search</p>
    </Popover>
  );
  return (
    <div className="text-search">
      <Whisper placement="bottom" trigger="active" speaker={speaker}>
        <InputGroup inside>
          <InputGroup.Addon>
            <Icon icon="search" />
          </InputGroup.Addon>
          <Input
            value={inputValue}
            onChange={(v) => {
              setFiltersStateParam(props.filterDef.code, v);
              if (v.length >= minLength) {
                setFilterValue(props.filterDef.code, v);
              } else {
                if (filterValue.length > 0) {
                  setFilterValue(props.filterDef.code, "");
                }
              }
            }}
            placeholder={props.placeholder}
            className={filterValue.trim().length > 0 ? "filled" : ""}
            spellCheck="false"
          />
          {inputValue.trim().length > 0 && (
            <InputGroup.Addon
              onClick={handleClear}
              style={{ cursor: "pointer" }}
            >
              <Icon icon="close" />
            </InputGroup.Addon>
          )}
        </InputGroup>
      </Whisper>
    </div>
  );
};

export default DynamicTextSearch;
